<template>
    <div class="w-full">
        <div class="w-full h-[11px] bg-default-1"></div>
        <div class="w-full h-[11px] bg-default-2"></div>
        <div class="w-full h-[11px] bg-white"></div>
    </div>
</template>